import { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';

import { AggregateData, HomeTitle, Marque } from '../../sections/landing/home';
import { Footer } from '../../sections/landing/footer';
import ContactUs from '../../sections/landing/contact/ContactUs';
import AboutUs from '../../sections/landing/about/AboutUs'; 

export default function HomePage() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <div ref={containerRef}>
      <Helmet>
        <title> መነሻ | የሰ/ሸ/ሃ/መ/አ/ስርዓት </title>
      </Helmet>
      <HomeTitle /> 
      <AggregateData />
      <AboutUs />
      <Marque />
      <ContactUs />
      <Footer containerRef={containerRef} />
    </div>
  );
}
